import styled from 'styled-components';
import { Modal } from 'reactstrap';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 0;
    border-left: 7px solid #db011c;

    .modal-body {
      padding: .25rem 1rem;

      @media only screen and (max-width: 550px) {
        font-size: .95rem;
      }

      ul {
        margin-bottom: 0;
        padding-left: 18px;
      }
    }

    .modal-header {
      border-bottom: none;
      
      > h5 {
        font-weight: 600;
      }
  
      .close {
        outline: 0;
        margin: -0.75rem -1rem -1rem auto;
      }
    }
  
    .modal-footer {
      border-top: none;
    }
  }
`;

const ModalSubHeader = styled.p`
  margin-bottom: .75rem;

  > strong {
    font-weight: 600;
    margin-left: .1rem;
    letter-spacing: .02em;
  }
`;

export {
  StyledModal,
  ModalSubHeader,
};
